import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { FormButtons } from "../../components";
import { useStore } from "../../helpers";
import _ from "lodash";
import dayjs from "dayjs";

export const DAFilters = observer((props: any) => {
  const rootStore = useStore();
  const { digitalArchiveStore } = rootStore;
  const { onDateSave } = props;

  const [selectedDate, setSelectedDate] = useState<string | null>(
    digitalArchiveStore.daFilters.date || null
  );

  const closeModal = () => {
    digitalArchiveStore.update_DAStoreProp("da_filter_modal", false);
  };

  const resetDate = async () => {
    setSelectedDate(null);

    const filters = _.clone(digitalArchiveStore.daFilters);
    filters.date = null;

    await digitalArchiveStore.update_da_filters(filters);
    await onDateSave();
  };

  return (
    <>
      <div className="flex flex-col">
        <label>Select Date</label>
        <input
          type="date"
          value={
            selectedDate
              ? dayjs(selectedDate, "DD-MM-YYYY").format("YYYY-MM-DD")
              : ""
          }
          onChange={(e) => {
            const val = e.target.value;
            setSelectedDate(val ? dayjs(val).format("DD-MM-YYYY") : null);
          }}
          className="form-input mt-1 w-2/3 px-1 py-1 border-gray-300 rounded-md"
        />
      </div>

      <FormButtons
        saveText="Apply"
        cancelText="Reset"
        onSave={async () => {
          const filters = _.clone(digitalArchiveStore.daFilters);
          filters.date = selectedDate;

          await digitalArchiveStore.update_da_filters(filters);
          await onDateSave();
          closeModal();
        }}
        onCancel={resetDate}
      />
    </>
  );
});
